<template>
  <div>
    <acheader></acheader>
      <div class="row mainbody">
        <div class="col-lg-2 col-md-4 col-sm-12">
            <orgsidebar></orgsidebar>
        </div>
        <div class="col-lg-10 col-md-8 col-sm-12">
          <div class="moduleWrapper">
            <div class="row">
               <div class="col-lg-12 text-right">
                  <button class="btn btn-secondary btn-short" @click="doAddPool">Add Pool</button>
               </div>
            </div>
            <div v-show="filterLength>0" v-for="n in filterLength" class="row mt-2">
              <div class="col-lg-3 col-md-6 col-sm-12" v-for="fitem in filteredPools(n)">
                <div class="card">
                  <span v-if="fitem.ScrollElement!==null" v-bind:id="fitem.ScrollElement"></span>
                  <div class="cardHeader row mb-2">
                    <div class="col-6">
                      License Pool
                    </div>
                    <div class="col-6 text-right">
                      <span v-show="fitem.IsAdmin===true">Administrator</span>
                      <span v-show="fitem.IsAdmin!==true">Data Viewer</span>
                    </div>
                  </div>

                  <div class="card-title" @click="goPoolDash(fitem.LicensePoolID)" role="button" aria-label="Go to Pool Dashboard">
                    <h3 v-html="fitem.LicensePoolName"></h3>
                  </div>
                  <div class="card-image text-center" @click="goPoolDash(fitem.LicensePoolID)" role="button" aria-label="Go to Pool Dashboard">
                    <img :src="fitem.FullImage" width="80" height="80" @error="doGenericAvatar(fitem)" alt="Pool Image" />
                  </div>
                  <div class="card-links pool-card-links">
                    <a :href="'/pool/'+fitem.LicensePoolID+'/members'" >Members</a>&nbsp;&nbsp;|&nbsp;&nbsp;
                    <a :href="'/pool/'+fitem.LicensePoolID+'/groups'" >Groups</a>&nbsp;&nbsp;|&nbsp;&nbsp;
                    <a :href="'/pool/'+fitem.LicensePoolID+'/products'" >Products</a><br />
                    <a :href="'/pool/'+fitem.LicensePoolID+'/bundles'" >Bundles</a>&nbsp;&nbsp;|&nbsp;&nbsp;
                    <a :href="'/pool/'+fitem.LicensePoolID+'/pooltrainingplans'" >Training Plans</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
       </div>
    </div>
      <b-modal title="Add License Pool" ref="addPoolModal" @ok="doAddPoolFinish">
        <div class="row">
          <div class="col-lg-4">Pool Name:</div>
          <div class="col-lg-8">
            <input type="text" class="fullWidth" v-model="nLicensePoolName" aria-label="License Pool Name" /> 
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-lg-4">Access Portal:</div>
          <div class="col-lg-8">
            <b-form-select class="ib" v-model="nPortal" :options="orgPortals"></b-form-select>
          </div>
        </div>
      </b-modal>
    <acfooter></acfooter>
  </div>
</template>

<style scoped>
    .card-title {
        margin-top:40px;
    }
    .pool-card-links {
        margin-top:25px;
    }
</style>

<script>
  import acheader from "../../layout/Header.vue"
  import acfooter from "../../layout/Footer.vue"
  import orgsidebar from "../../layout/Organization/Sidebar.vue"

  export default {
    name: 'OrgPools',
    components:{acheader,acfooter,orgsidebar},
    data() {
      return {
        filterLength:0,
        nLicensePoolName:null,
        nPortal:null,
        orgPortals:[]
      }
    },
  methods: {
      buildPage: function() {
       
        if (this.thesePools.length>=4) {
          if (this.thesePools.length%4>0) {
            this.filterLength = (this.thesePools.length-(this.thesePools.length%4))/4+1;
          }
          else {
            this.filterLength = this.thesePools.length/4;
          }
    
        }
        else if (this.thesePools.length>0) {
          this.filterLength=1;
        }

        window.scrollTo(0,0);
      },
      doAddPool: function() {
        this.apiCommand([
          {
            Operation: "Organization",
            Function: "GetPortals",
            Fields: {
                OrganizationID: this.$route.params.id
            }
          }
        ]).then(r=>{
          var cr = JSON.parse(r.CommandResult);
          var portals = JSON.parse(cr.returnObjects[0].returnObject);

          this.orgPortals=[];

          this.orgPortals.push({
            html: "Training Center",
            value: "B9360F8C-7F67-4E0A-A3E4-2730AACE0412"
          });

          for(var portal of portals) {
            this.orgPortals.push({
              html: portal.PortalName,
              value: portal.PortalID
            });
          }

          this.nPortal="B9360F8C-7F67-4E0A-A3E4-2730AACE0412";
          this.nLicensePoolName="";

          this.$refs.addPoolModal.show();
        })
      },
      doAddPoolFinish: function() {

        this.apiCommand([
           {
             Operation: "LicensePool",
             Function: "Add",
             Fields: {
               Portal: this.nPortal,
               LicensePoolName: this.nLicensePoolName,
               Organization: this.$route.params.id,
               CompanyName: this.sdata.activeorg.OrganizationName,
               StreetAddress1: "",
               StreetAddress2: "",
               City: "",
               State: "",
               Zip: "",
               Phone: ""
             }
           }
        ]).then(r=>{
          var cr = JSON.parse(r.CommandResult);
          if (cr.returnObjects[0].returnObject==="Invalid Operation") {
            this.popDialog(1, "There was a problem adding the license pool. Please check that the name is between 1 and 255 characters");
          }
          else {
            this.doPage(true).then(r=>{
              this.bootstrapOrg(this.$route.params.id);
              this.popDialog(0, "License pool added successfully");
              this.buildPage();
            });
          }
        })


      },
      doGenericAvatar: function(pool) {
        pool.FullImage="/pool.svg";
        this.$forceUpdate();
      },
      filteredPools: function (n) {
        return this.thesePools.slice((n-1)*4, (n-1)*4+4)
      },
      goPoolDash: function(poolid) {
        this.$router.push({ name: 'pooldash', params: { id: poolid } });
      },
      goPoolMembers: function(poolid) {
        this.$router.push({ name: 'poolmembers', params: { id: poolid } });
      },
      goPoolGroups: function(poolid) {
        this.$router.push({ name: 'poolgroups', params: { id: poolid } });
      },
      goPoolProducts: function(poolid) {
        this.$router.push({ name: 'poolproducts', params: { id: poolid } });
      },
      goPoolBundles: function(poolid) {
        this.$router.push({ name: 'poolbundles', params: { id: poolid } });
      },
      goPoolCurriculum: function(poolid) {
        this.$router.push({ name: 'poolcurricula', params: { id: poolid } });
      }
   },
    mounted() {
      this.doPage().then(r=>{

        this.bootstrapOrg(this.$route.params.id);
        this.buildPage();

      })
    }
  }
</script>
